import React from "react";
import { useNavigate } from "react-router-dom";
import "./home-page.css";
import SEO from "./components/SEO";
import MarketingNavbar from "./components/MarketingNavbar";
import MarketingFooter from "./components/MarketingFooter";
export default function MenuDigitaleRistoranti() {
  const navigate = useNavigate();

  return (
    <div className="home-pro">
      <SEO
        title="Menu Digitale per Ristoranti e Pizzerie | QrMenu Italia"
        description="QrMenu Italia aiuta ristoranti e pizzerie a gestire un menu digitale sempre aggiornato, ordini dal tavolo facoltativi, cucina, stampa comande, asporto con OTP e intelligenza artificiale. Piani a partire da 0€/mese."
        canonical="https://qrmenu-italia.it/menu-digitale-ristoranti"
        image="https://qrmenu-italia.it/og-ristoranti-pizzerie.jpg"
        keywords="menu digitale ristorante, menu digitale pizzeria, menu qr ristorante, menu qr pizzeria, ordini dal tavolo, asporto con otp, stampa comande, qrmenu"
      />

      <MarketingNavbar />

      {/* HERO */}
      <section className="hp-hero">
        <div className="hp-hero-noise" />
        <div className="hp-hero-glow" />

        <div className="hp-hero-inner">
          <div className="hp-hero-eyebrow">
            <span className="hp-dot" />
            MENU DIGITALE PER RISTORANTI E PIZZERIE
          </div>

          <h1 className="hp-hero-h1">
            Un menu digitale su misura,
            <span className="hp-hero-accent">
              sia per il ristorante che per la pizzeria.
            </span>
          </h1>

          <p className="hp-hero-sub">
            Aggiorni piatti, pizze, ingredienti, allergeni e prezzi in pochi secondi.
            Attivi solo ciò che ti serve: ordini dal tavolo, cucina, stampa comande,
            asporto con OTP e intelligenza artificiale, senza cambiare il tuo modo di lavorare.
          </p>

          <div className="hp-hero-pills">
            <span className="hp-pill">✦ Menu sempre aggiornato</span>
            <span className="hp-pill">✦ Ordini dal tavolo facoltativi</span>
            <span className="hp-pill">✦ Asporto con codice OTP</span>
            <span className="hp-pill">✦ Ordini inviati in cucina</span>
            <span className="hp-pill">✦ Intelligenza Artificiale per cliente e sala</span>
            <span className="hp-pill">✦ Piani a partire da 0€/mese</span>
          </div>

          <div className="hp-hero-actions">
            <button className="hp-btn-demo" onClick={() => navigate("/demo")}>
              Prova Gratis 7 Giorni
              <span className="hp-btn-arrow">→</span>
            </button>

            <button className="hp-btn-primary" onClick={() => navigate("/contatti")}>
              Richiedi informazioni
            </button>
          </div>
        </div>

        <div className="hp-hero-mockup">
          <div className="hp-phone">
            <div className="hp-phone-notch" />

            <div className="hp-phone-screen">
              <div className="hp-screen-header">
                <div className="hp-screen-tag">Tavolo 8</div>
                <div className="hp-screen-time">20:42</div>
              </div>

              <div className="hp-screen-category active">Pizze</div>
              <div className="hp-screen-category">Antipasti</div>

              <div className="hp-screen-item">
                <div className="hp-screen-item-img" />
                <div className="hp-screen-item-info">
                  <div className="hp-screen-item-name">Pizza Margherita</div>
                  <div className="hp-screen-item-price">€ 8,50</div>
                </div>
                <div className="hp-screen-item-add">+</div>
              </div>

              <div className="hp-screen-item">
                <div className="hp-screen-item-img alt" />
                <div className="hp-screen-item-info">
                  <div className="hp-screen-item-name">Tartare di tonno</div>
                  <div className="hp-screen-item-price">€ 14,00</div>
                </div>
                <div className="hp-screen-item-add">+</div>
              </div>

              <div className="hp-screen-ai">
                <span className="hp-screen-ai-dot" />
                Ordine inviato in cucina • sala avvisata
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SEO CONTENT */}
      <section className="hp-problem">
        <div className="hp-problem-inner">
          <div className="hp-section-tag">Menu digitale per ristoranti e pizzerie</div>

          <h2 className="hp-section-h2">
            Un menu facile da aggiornare, in sala come in pizzeria
          </h2>

          <p className="hp-seo-text">
            Piatti del giorno, pizze speciali, ingredienti, allergeni, vini e prezzi
            cambiano spesso. Con QrMenu li modifichi in pochi passaggi, senza
            ristampare nulla, e il cliente trova sempre il menu corretto dal telefono,
            senza scaricare app né creare un account.
          </p>

          <p className="hp-seo-text">
            Gli ordini dal tavolo restano facoltativi: li attivi solo se sono adatti
            al tuo modo di lavorare, oppure usi QrMenu come semplice menu digitale.
            Se li attivi, le comande arrivano subito in cucina e, se configurata,
            parte anche la stampa automatica.
          </p>

          <p className="hp-seo-text">
            Se offri l'asporto, QrMenu può gestire ordini verificati con codice OTP
            e slot orari. E se vuoi, l'intelligenza artificiale aiuta a valorizzare
            piatti e pizze, suggerire abbinamenti e tradurre il menu per i clienti stranieri.
          </p>
        </div>
      </section>

      {/* FEATURES */}
      <section className="hp-features">
        <div className="hp-section-tag">Cosa cambia per il tuo locale</div>

        <h2 className="hp-section-h2">
          Dal menu QR a uno strumento utile per il servizio
        </h2>

        <div className="hp-features-grid">
          <div className="hp-feat-card">
            <h3 className="hp-feat-title">Menu sempre aggiornato</h3>
            <p className="hp-feat-desc">
              Modifichi piatti, pizze, ingredienti, allergeni, foto e prezzi
              in pochi secondi, dal telefono o dal computer.
            </p>
          </div>

          <div className="hp-feat-card">
            <h3 className="hp-feat-title">Ordini dal tavolo solo se vuoi</h3>
            <p className="hp-feat-desc">
              Puoi lasciare il menu solo in consultazione oppure permettere
              al cliente di ordinare dal telefono, se è adatto al tuo servizio.
            </p>
          </div>

          <div className="hp-feat-card hp-feat-card--featured">
            <h3 className="hp-feat-title">Cucina e stampa più ordinate</h3>
            <p className="hp-feat-desc">
              Se attivi gli ordini, le comande arrivano in cucina in modo chiaro
              e possono essere stampate automaticamente se configurato.
            </p>
          </div>

        <div className="hp-feat-card">
  <h3 className="hp-feat-title">Sala e camerieri più informati</h3>
  <p className="hp-feat-desc">
    Il personale riceve notifiche per ordini pronti e richieste dal tavolo
    e può essere aiutato dagli alert intelligenti a capire dove potrebbe
    servire attenzione durante il servizio.
  </p>
</div>

          <div className="hp-feat-card">
            <h3 className="hp-feat-title">Asporto con OTP</h3>
            <p className="hp-feat-desc">
              Ricevi ordini da asporto verificati con codice OTP, riducendo
              ordini fantasma ed errori sul ritiro.
            </p>
          </div>

<div className="hp-feat-card">
  <h3 className="hp-feat-title">Intelligenza artificiale</h3>
  <p className="hp-feat-desc">
    Aiuta il cliente nella scelta di piatti, pizze, abbinamenti e prodotti
    aggiuntivi, supporta la sala con alert intelligenti e aiuta il gestore
    con contenuti e traduzioni del menu.
  </p>
</div>
        </div>
      </section>

      {/* CTA */}
      <section className="hp-final">
        <div className="hp-final-noise" />
        <div className="hp-final-inner">
          <h2 className="hp-final-h2">Vuoi provarlo nel tuo locale?</h2>

          <p className="hp-final-sub">
            Crea una prova gratuita e capisci subito quali funzioni ti servono
            davvero. Piani a partire da 0€/mese, attivi solo ciò che ti serve.
          </p>

          <button className="hp-btn-primary hp-btn-xl" onClick={() => navigate("/demo")}>
            Prova Gratis 7 Giorni
            <span className="hp-btn-arrow">→</span>
          </button>
        </div>
      </section>
            <MarketingFooter />
    </div>
  );
}
